import FencePost from "./FencePost";
import FencePanel from "../panels/FencePanel";
import BrickWall from './BrickWall';
import { useLoader } from '@react-three/fiber';
import * as THREE from 'three';

const FenceUnit = ({ index, width, height, panelHeight, panelGap, bottomSpace, almColor, glassColor, angle, position, panelCount, caseled, topLed,
  category, subCategory
}) => {

  const topProfileHeight = 0.1;
  const lazerTexture = useLoader(THREE.TextureLoader, '/lazer_kesim.png');
  panelGap = panelGap == 0 ? 0.002 : 0;
  const footHeight = index == 0 ? 0.05 : 0;

  return (
    <group position={position}>
      {/* Sol direk */}
      <FencePost
        height={height}
        color={almColor}
        led={caseled}
        topLed={topLed}
        angle={angle}
        isShowAnkraj={index == 0}
        position={[0, height / 2, 0]}
      />

      {/* Sağ direk */}
      <FencePost
        height={height}
        color={almColor}
        led={caseled}
        topLed={topLed}
        angle={angle}
        isShowAnkraj={index == 0}
        position={[width, height / 2, 0]}
      />

      {/* Duvar üstü beton */}
      {index == 0 && (<mesh position={[width / 2, -0.1, 0]}>
        <boxGeometry args={[width + 0.7, 0.2, 0.7]} />
        <meshStandardMaterial color="#cccccc" />
      </mesh>)}

      {/* Tuğla duvar */}
      {index == 0 && (<BrickWall width={width} position={[width / 2, -1.2, 0]} />)}

      {/* Üst profil + LED */}
      {topLed === "2" && (
        <>
          {/* Üst profil kutusu */}
          <mesh position={[width / 2, height + topProfileHeight, 0]}>
            <boxGeometry args={[width + 0.2, topProfileHeight, 0.2]} />
            <meshStandardMaterial color={almColor} />
          </mesh>

          {/* Altına LED şerit – ince ve parlak */}
          <mesh
            position={[width / 2, height + topProfileHeight / 2, 0.099]} // 0.101 öne çıkıntı
          >
            <boxGeometry args={[width + 0.2, 0.01, 0.005]} />
            <meshStandardMaterial
              color="yellow"
              emissive="yellow"
              emissiveIntensity={2}
            />
          </mesh>

          {/* Altına LED şerit – ince ve parlak */}
          <mesh
            position={[width / 2, height + topProfileHeight / 2, -0.099]} // 0.101 öne çıkıntı
          >
            <boxGeometry args={[width + 0.2, 0.01, -0.005]} />
            <meshStandardMaterial
              color="yellow"
              emissive="yellow"
              emissiveIntensity={2}
            />
          </mesh>
        </>
      )}

      {/* CAM */}
      {category == 'cam' && subCategory != 'lazer' && (
        <FencePanel
          width={width}
          height={height - bottomSpace - 0.02}
          color={glassColor}
          thickness={0.03}
          position={[
            width / 2,
            height / 2 + bottomSpace - 0.01,
            0
          ]}
        />
      )}

      {/* Yatay paneller */}
      {category != 'cam' && (subCategory === 'panel' //+
        || subCategory === 'panel_100' //+
        || subCategory === 'gunes_kirici'
        || subCategory === 'gunes_kirici2'
        || subCategory === 'yaprak_panel'
        || subCategory === 'panel_70'//+
      ) && (
          Array.from({ length: panelCount }).map((_, i) => {
            const y = 0.05 + bottomSpace + i * (panelHeight + panelGap) + panelHeight / 2;
            return (
              <FencePanel
                key={i}
                width={width}
                height={panelHeight}
                color={almColor}
                position={[width / 2, y, 0]}
                subCategory={subCategory}
              />
            );
          })
        )}

      {/* LAZER ON*/}
      {subCategory === 'lazer' && (
        <mesh position={[width / 2, height / 2+footHeight, 0]}>
          <planeGeometry args={[width, height - bottomSpace-footHeight]} />
          <meshBasicMaterial
            map={lazerTexture}
            transparent
          />
        </mesh>
      )}
      {/* LAZER ARKA*/}
      {subCategory === 'lazer' && (
        <mesh position={[width / 2, height / 2+footHeight, 0]}>
          <planeGeometry args={[width, height-bottomSpace-footHeight]} />
          <meshBasicMaterial
            map={lazerTexture}
            transparent
            side={THREE.DoubleSide}
          />
        </mesh>
      )}

      {/* CAM veya LAZER için ince çerçeve */}
      {(category === 'cam' || subCategory === 'lazer') && (() => {
        const frameThickness = 0.02;
        const frameDepth = 0.05;
        const frameHeight = height - bottomSpace;
        const frameWidth = width;
        

        return (
          <>
            {/* Sol dikme */}
            <mesh position={[0.07 + frameThickness * 2, frameHeight / 2 + footHeight, 0]}>
              <boxGeometry args={[frameThickness, frameHeight - footHeight, frameDepth]} />
              <meshStandardMaterial color={almColor} />
            </mesh>

            {/* Sağ dikme */}
            <mesh position={[width - frameThickness * 2 - 0.07, frameHeight / 2 + footHeight, 0]}>
              <boxGeometry args={[frameThickness, frameHeight - footHeight, frameDepth]} />
              <meshStandardMaterial color={almColor} />
            </mesh>

            {/* Üst çerçeve */}
            <mesh position={[width / 2, height - frameThickness/2, 0]}>
              <boxGeometry args={[frameWidth, frameThickness, frameDepth]} />
              <meshStandardMaterial color={almColor} />
            </mesh>

            {/* Alt çerçeve */}
            <mesh position={[width / 2, bottomSpace + footHeight, 0]}>
              <boxGeometry args={[frameWidth, frameThickness, frameDepth]} />
              <meshStandardMaterial color={almColor} />
            </mesh>
          </>
        );
      })()}
    </group>
  );
};

export default FenceUnit;